module.exports = __webpack_public_path__ + "media/img/before_buy_image_2-c4e7d848.png";